import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const questionAddedToCluster = async (payload) => {
  const builder = new UrlBuilder(`/admin/questions/insert`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const listOfClusterQuestions = async (payload) => {
  const builder = new UrlBuilder(`/admin/questions/list`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
